import React from 'react';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';

import CollapsableMenuItem from 'secured/components/layout/menu/CollapsableMenuItem';
import ActiveLink from 'secured/components/layout/menu/ActiveLink';

const ControlPanel = ({ company, isCollapsed, location, permissions, t, toggleMenu }) =>
  permissions['acl.roles.get'] || permissions['acl.users.get'] ? (
    <CollapsableMenuItem
      label={t('menu.control_panel')}
      opened={!isCollapsed}
      icon="cogs"
      handleToggle={(collapsed) => toggleMenu('control_panel', collapsed)}
    >
      <ul className="submenu-list">
        {/* {permissions["acl.inpc.get"] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={`/companies/${company.id}/notifications_config`}
            >
              <i className="fa fa-bell fa-lg" />
              {t("menu.notifications_config")}
            </ActiveLink>
          </li>
        )} */}
        {permissions['acl.inpc.get'] && (
          <li>
            <ActiveLink pathname={location.pathname} to={`/companies/${company.id}/inpc`}>
              <i className="fa fa-money fa-lg" />
              {t('menu.inpc')}
            </ActiveLink>
          </li>
        )}
        {/* {permissions["acl.exchanges.get"] && (
          <li>
            <ActiveLink pathname={location.pathname} to={`/companies/${company.id}/exchange`}>
              <i className="fa fa-money fa-lg" />
              {t("menu.exchange")}
            </ActiveLink>
          </li>
        )} */}
        {permissions['acl.roles.get'] && (
          <li>
            <ActiveLink pathname={location.pathname} to={`/companies/${company.id}/roles`}>
              <i className="fa fa-shield fa-lg" />
              {t('menu.roles')}
            </ActiveLink>
          </li>
        )}
        {permissions['acl.users.get'] && (
          <li>
            <ActiveLink pathname={location.pathname} to={`/companies/${company.id}/users`}>
              <i className="fa fa-users fa-lg" />
              {t('menu.users')}
            </ActiveLink>
          </li>
        )}

        {/* <li>
          <a href="https://saaf-help.freshdesk.com/" target="_blank" rel="noopener noreferrer">
            <i className="fa fa-book fa-lg" />
            {t('menu.support')}
          </a>
        </li> */}

        <li>
          <a href="https://mantenimiento.activofijosaaf.com" target="_blank" rel="noopener noreferrer">
            <i className="fa fa-id-card fa-lg" />
            {t('menu.maintenance')}
          </a>
        </li>
      </ul>
    </CollapsableMenuItem>
  ) : null;

export default withRouter(translate()(ControlPanel));



// WEBPACK FOOTER //
// src/modules/secured/components/layout/menu/ControlPanel.js